import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Modal from 'react-modal';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HelmetProvider } from 'react-helmet-async';

import { ToastContextProvider } from "./contexts/toastContext";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            retry: 1,
        },
    },
});
Modal.setAppElement('#root');
// 1. On définit le contenant
const rootElement = document.getElementById('root');

// 2. On définit l'application (ton JSX) dans une constante
const Application = (
    <HelmetProvider>
        <QueryClientProvider client={queryClient}>
            <ToastContextProvider>
                <Router>
                    <React.StrictMode>
                        <App />
                    </React.StrictMode>
                </Router>
                <ReactQueryDevtools initialIsOpen={false} />
            </ToastContextProvider>
        </QueryClientProvider>
    </HelmetProvider>
);

// 3. La logique de rendu hybride
if (rootElement.hasChildNodes()) {
    // Cas Production : Le HTML est déjà là grâce à react-snap
    // On utilise hydrateRoot pour React 18
    ReactDOM.hydrateRoot(rootElement, Application);
} else {
    // Cas Développement : Page vide, on crée la racine normalement
    const root = ReactDOM.createRoot(rootElement);
    root.render(Application);
}